import Vue from "vue";
import Vuex from "vuex";
import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

import moduleProject from "./modules/project";
import moduleVessel from "./modules/vessel";
import moduleProjectAsset from "./modules/project-asset";
import moduleActivityConfiguration from "./modules/activity-configuration";
import moduleTool from "./modules/tool";
import moduleMacroActivity from "./modules/macro-activity";
import moduleProgressAnalysisMD from "./modules/progress-analysis";
import moduleTrencher from "./modules/trencher";
import moduleSoil from "./modules/soil";
import moduleRanklist from "./modules/ranklist";
import moduleArea from "./modules/area";
import moduleCable from "./modules/cable";
import moduleDprOutput from "./modules/dpr-output";
import moduleConfiguration from "./modules/configuration";
import moduleEstimate from "./modules/estimate";
import moduleQhse from "./modules/qhse";
import moduleEquipmentStatus from "./modules/equipment-status";
import moduleActivityCategory from "./modules/activity-category";
import moduleActivityMaster from "./modules/activity-master";
import moduleActivityType from "./modules/activity-type";
import moduleErrorLog from "./modules/error-log";
import moduleUser from "./modules/user";
import moduleRole from "./modules/role";
import moduleUserInRoles from "./modules/user-role";
import moduleUserInProjects from "./modules/user-project";
import moduleTranslation from "./modules/translation";
import modulePdfConfiguration from "./modules/pdf-configuration";

//#region Vessel Modules

import moduleCompletionTable from "./vessel-modules/completion-table";
import moduleComment from "./vessel-modules/comment";
import moduleCommentEvent from "./vessel-modules/comment-event";
import moduleCommentExecutive from "./vessel-modules/comment-executive";
import moduleContactNumber from "./vessel-modules/contact-number";
import moduleDListExternal from "./vessel-modules/dlist-ext";
import moduleDListInternal from "./vessel-modules/dlist-int";
import moduleDprHeader from "./vessel-modules/dpr-header";
import moduleDprData from "./vessel-modules/dpr-data";
import modulePrjSearch from "./vessel-modules/project";
import modulePersonnel from "./vessel-modules/personnel";
import moduleProgressAnalysis from "./vessel-modules/progress-analysis";
import moduleVesselActivity from "./vessel-modules/vessel-activity";
import moduleVesselEquipmentStatus from "./vessel-modules/vessel-equipment-status";
import moduleVesselMacroActivity from "./vessel-modules/vessel-macro-activity";
import moduleVesselQhse from "./vessel-modules/vessel-qhse";
import moduleWeather from "./vessel-modules/weather";
import moduleDprSignature from "./vessel-modules/dpr-signature";
//#endregion

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    m_project: moduleProject,
    m_vessel: moduleVessel,
    m_passet: moduleProjectAsset,
    m_activity: moduleActivityMaster,
    m_actCat: moduleActivityCategory,
    m_actCfg: moduleActivityConfiguration,
    m_actType: moduleActivityType,
    m_tool: moduleTool,
    m_mActivity: moduleMacroActivity,
    m_mProgressAnalysisMD: moduleProgressAnalysisMD,
    m_trencher: moduleTrencher,
    m_soil: moduleSoil,
    m_ranklist: moduleRanklist,
    m_area: moduleArea,
    m_cable: moduleCable,
    m_dprOutput: moduleDprOutput,
    m_configuration: moduleConfiguration,
    m_estimate: moduleEstimate,
    m_qhse: moduleQhse,
    m_equip: moduleEquipmentStatus,
    m_errorLog: moduleErrorLog,
    m_user: moduleUser,
    m_role: moduleRole,
    m_userInRoles: moduleUserInRoles,
    m_userInProjects: moduleUserInProjects,
    m_translation: moduleTranslation,
    m_pdfCfg: modulePdfConfiguration,

    mv_completion: moduleCompletionTable,
    mv_comment: moduleComment,
    mv_commentEvent: moduleCommentEvent,
    mv_commentExecutive: moduleCommentExecutive,
    mv_dListExternal: moduleDListExternal,
    mv_dListInternal: moduleDListInternal,
    mv_dprHeader: moduleDprHeader,
    mv_dprData: moduleDprData,
    mv_prjSearch: modulePrjSearch,
    mv_personnel: modulePersonnel,
    mv_progressAnalysis: moduleProgressAnalysis,
    mv_contactNumber: moduleContactNumber,
    mv_vesselActivity: moduleVesselActivity,
    mv_vesselEquipmentStatus: moduleVesselEquipmentStatus,
    mv_vesselMacroActivity: moduleVesselMacroActivity,
    mv_vesselQhse: moduleVesselQhse,
    mv_weather: moduleWeather,
    mv_dprSignature: moduleDprSignature,
  },
  state,
  mutations,
  actions,
  getters,
});
